var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_186_2223)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4891 1.17037C18.8062 -0.147611 20.9437 -0.147611 22.2609 1.17037L22.8281 1.7385C24.1453 3.05662 24.1453 5.19365 22.8281 6.51084L13.5844 15.7593C13.1766 16.1624 12.675 16.4577 12.1219 16.6171L7.43437 17.9577C7.04062 18.0702 6.61875 17.9577 6.32812 17.6296C6.04219 17.3812 5.92969 16.9593 6.04219 16.5655L7.38281 11.878C7.54219 11.3249 7.8375 10.8233 8.24062 10.4155L17.4891 1.17037ZM20.6297 2.76131C20.2312 2.32209 19.5187 2.32209 19.0781 2.76131L17.7141 4.1249L19.875 6.28584L21.2391 4.87959C21.6797 4.48115 21.6797 3.76865 21.2391 3.32944L20.6297 2.76131ZM9.54844 12.4968L8.76094 15.239L11.5031 14.4515C11.6906 14.3999 11.8547 14.3015 11.9906 14.1655L18.2859 7.8749L16.125 5.71397L9.83437 12.0093C9.69844 12.1452 9.6 12.3093 9.54844 12.4968ZM9.375 2.9999C9.99844 2.9999 10.5 3.50381 10.5 4.1249C10.5 4.74834 9.99844 5.2499 9.375 5.2499H4.125C3.08953 5.2499 2.25 6.08897 2.25 7.1249V19.8749C2.25 20.9108 3.08953 21.7499 4.125 21.7499H16.875C17.9109 21.7499 18.75 20.9108 18.75 19.8749V14.6249C18.75 14.0015 19.2516 13.4999 19.875 13.4999C20.4984 13.4999 21 14.0015 21 14.6249V19.8749C21 22.153 19.1531 23.9999 16.875 23.9999H4.125C1.84687 23.9999 0 22.153 0 19.8749V7.1249C0 4.84678 1.84687 2.9999 4.125 2.9999H9.375Z",
    fill: "#A0938C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_186_2223"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.c4bb6815206fbbbc1cb6432a38966c6b.svg";
export { ForwardRef as ReactComponent };